export enum TabIndex {
  Portfolio = 0,
  Segments = 1,
  Lists = 2,
  Board = 3,
}

export const TabIndexToUrl = {
  [TabIndex.Portfolio]: "portfolio",
  [TabIndex.Segments]: "segments",
  [TabIndex.Lists]: "lists",
  [TabIndex.Board]: "board",
};
